export default __webpack_public_path__ + "static/media/iniComputacion_utn.e568721d.png";